import React from 'react';
import { PasswordValidation } from '../utils/passwordValidator';
import { t } from '../i18n';

interface PasswordRequirementsProps {
  validation: PasswordValidation;
  show: boolean;
}

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ validation, show }) => {
  if (!show) return null;

  const requirements = [
    { met: validation.hasMinLength, label: t('password.requirements.minLength') },
    { met: validation.hasUppercase, label: t('password.requirements.uppercase') },
    { met: validation.hasLowercase, label: t('password.requirements.lowercase') },
    { met: validation.hasNumber, label: t('password.requirements.number') },
    { met: validation.hasSpecialCharacter, label: t('password.requirements.specialCharacter') },
  ];

  return (
    <div className="password-requirements">
      {requirements.map((req, index) => (
        <div key={index} className={`password-requirement ${req.met ? 'met' : 'unmet'}`}>
          <span className="requirement-icon">
            {req.met ? (
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M11.6667 3.5L5.25 9.91667L2.33333 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            ) : (
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
            )}
          </span>
          <span className="requirement-label">{req.label}</span>
        </div>
      ))}
    </div>
  );
};

export default PasswordRequirements;
